import { useEffect, useState } from "react";
import { Form } from "./components/Form";
import { Preview } from "./components/Preview";
import { loadDraft, saveDraft } from "./lib/storage";
import { emptySelection } from "./lib/form";
import type { Selection } from "./lib/types";

type View = "form" | "preview";

export function App() {
  const [view, setView] = useState<View>("form");
  const [selection, setSelection] = useState<Selection>(
    () => loadDraft() ?? emptySelection()
  );

  useEffect(() => {
    saveDraft(selection);
  }, [selection]);

  return (
    <div className={`app ${view === "preview" ? "app--preview" : ""}`}>
      {view === "form" ? (
        <Form
          selection={selection}
          onChange={setSelection}
          onPreview={() => setView("preview")}
        />
      ) : (
        <Preview selection={selection} onBack={() => setView("form")} />
      )}

      <footer className="site-footer no-print">
        © {new Date().getFullYear()} Workout Generator
      </footer>
    </div>
  );
}
